'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'xmark';
var width = 384;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M379.4 91.3L390.8 80 368.1 57.4 356.8 68.7 192.1 233.4 27.4 68.7 16.1 57.4-6.5 80 4.8 91.3 169.5 256 4.8 420.7-6.5 432 16.1 454.6 27.4 443.3 192.1 278.6 356.8 443.3 368.1 454.6 390.8 432 379.4 420.7 214.8 256 379.4 91.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;